module.exports = __webpack_public_path__ + "static/chitkara-aa615bdbd06bafafb9bb4f338d23b266.png";